<template>
    <div class="app__tab first_step">
        <div class="app__tab_title" @click="goToStep(1)">
            <span>1</span>
            <p>Поиск марки и модели</p>
        </div>
        <transition name="fade">
            <div class="app__tab-wrapper" v-show="step === 1">
                <treeselect
                    :key="count"
                    v-model="markId"
                    :options="listOfManufacturers"
                    openDirection="bottom"
                    :normalizer="manufacNormilizer"
                    :clearable="false"
                    @select="setManufactorer"
                    placeholder="Введите марку"
                    ref="treeselect"
                />
                <treeselect
                    :class="{ disable: !markId }"
                    v-model="selectedModel"
                    :options="listOfModels"
                    openDirection="bottom"
                    :clearable="false"
                    :normalizer="modelNormilizer"
                    placeholder="Введите модель"
                    noOptionsText="Моделей для данной марки нет"
                    valueFormat="object"
                />
                <button
                    class="btn"
                    :class="{ disable: !selectedModel }"
                    @click="goToStep(2)"
                >
                    Показать
                </button>
            </div>
        </transition>
    </div>
</template>
<script>
export default {
    props: {
        API_URL: { type: String },
        step: { type: Number },
    },
    data: () => ({
        listOfManufacturers: [],
        markId: null,
        count: 1,
        listOfModels: [],
        modelId: null,

        currentModel: null,
    }),
    /**
     * Search for car marks and check for the presence of information in the storage
     */
    mounted() {
        this.responseMarks();
        this.prefetchStorageData();
    },
    methods: {
        goToStep(step) {
            this.$emit("goToStep", step);
        },
        /**
         * prefetchData
         */
        prefetchStorageData() {
            this.markId = this.selectedMark ? this.selectedMark.id : null;
            this.modelId = this.selectedModelId;

            if (this.markId !== null) {
                this.responseModels();
            }
        },
        /**
         * normalizers to car marks
         */
        manufacNormilizer(node) {
            return {
                id: node.id,
                label: node.mark,
            };
        },
        /**
         * normalizers to car marks
         */
        modelNormilizer(node) {
            return {
                id: node.id,
                label: node.modelDisplayName,
            };
        },

        /**
         * sending a request to receive marks list
         */
        responseMarks() {
            fetch(`${this.API_URL}list`, {
                headers: {
                    Authorization: "Bearer e09421f76fc24dbbbfdcf0adb9a87c5a",
                },
            })
                .then((response) => {
                    return response.json();
                })
                .then((response) => {
                    this.listOfManufacturers = response.data;
                });
        },
        /**
         * sending a request to receive models list
         */
        responseModels() {
            fetch(`${this.API_URL}modelList/${this.markId}`, {
                headers: {
                    Authorization: "Bearer e09421f76fc24dbbbfdcf0adb9a87c5a",
                },
            })
                .then((response) => {
                    return response.json();
                })
                .then((response) => {
                    return (this.listOfModels = response.data);
                });
        },
        /**
         * Update value in storage and reset model value
         */
        setManufactorer(node) {
            this.$store
                .dispatch("updateStateValue", {
                    target: "manufactorer",
                    value: node,
                })
                .then(() => {
                    this.responseModels();
                })
                .then(() => {
                    this.$store
                        .dispatch("updateStateValue", {
                            target: "model",
                            value: null,
                        })
                        .then(() => {
                            this.$emit("resetEngines");
                        });
                });
        },
    },
    computed: {
        /**
         * ID выбранной марки
         */
        selectedMark() {
            this.count += 1;
            if (!this.$store.getters["getValue"]("manufactorer")) {
                this.markId = null;
                this.modelId = null;
            }
            return this.$store.getters["getValue"]("manufactorer");
        },
        /**
         * Отслеживание модели авто
         */
        selectedModel: {
            get() {
                if (!this.$store.getters["getValue"]("model")) {
                    this.modelId = null;
                }
                return this.$store.getters["getValue"]("model");
            },
            set(value) {
                let oldModel = Object.assign({}, this.selectedModel);
                if (value) {
                    this.$store
                        .dispatch("updateStateValue", {
                            target: "model",
                            value: value,
                        })
                        .then(() => {
                            this.$store
                                .dispatch("updateStateValue", {
                                    target: "maxAvailableStep",
                                    value: 2,
                                })
                                .then(() => {
                                    if (oldModel || value.id !== oldModel.id) {
                                        this.$emit("getEnginesFromApi");
                                    }
                                });
                        });
                }
            },
        },
        /**
         * ID выбранной модели
         */
        selectedModelId() {
            return (this.modelId = this.selectedModel
                ? this.selectedModel.id
                : null);
        },
    },
};
</script>